module.exports = __webpack_public_path__ + "img/ppe_safety_officer_sign.bdea9962.png";